import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { IncidentUploadStatusService } from './incident-upload-status.service';
import { DATAUPLOADSTATUSCOLUMS, DATAUPLOADCLUSTERCOLUMS } from '../common/constants/labels';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-incident-upload-status',
  templateUrl: './incident-upload-status.component.html',
  styleUrls: ['./incident-upload-status.component.scss']
})
export class IncidentUploadStatusComponent implements OnInit {
  title = 'Data Upload Status';
  loading = false;
  datauploadStatusCols = DATAUPLOADSTATUSCOLUMS;
  datauploadClusterCols = DATAUPLOADCLUSTERCOLUMS;
  incidentUploadForm = new FormGroup({
    clusters: new FormControl(),
    uploadsite: new FormControl(),
    bigcategories: new FormControl(),
    currency: new FormControl()
  });
  validationMsg = '';
  showValidation = false;
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  cluster: string[] = [];
  clusterdefault = '';
  dataAvailable = false;
  incidentDataUploadStatusDataSource = [];
  overallDataUploadStatusDataSource = [];
  incidentDataUploadClusterDataSource = [];
  incidentDataUploadClusterDataArray = [];
  seletedTabIndex = 0;
  dayArray = [5, 6, 7];
  h1MonthArray = [7, 8, 9]; // [Jul,Aug,Sep];
  h2MonthArray = [1, 2, 3]; // [Jan,Feb,Mar];
  currentDate =  new Date();
  showData = true;
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;
  constructor(private dashboardsqlservice: DashboardSqlService, private incidentStatusService: IncidentUploadStatusService) { }

  ngOnInit() {
    // this.showIncidentUploadDetails();
    this.getClusterData();
    this.getIncidentDataUploadData();
    this.getIncidentDataUploadClusterData();
  }

  showIncidentUploadDetails() {
    const month = this.currentDate.getUTCMonth() + 1; // months from 1-12
    const day = this.currentDate.getUTCDate();
    const year = this.currentDate.getUTCFullYear();
    if (this.h1MonthArray.some(m => m === month) || this.h2MonthArray.some(m => m === month)) {
      this.showData = true;
    } else {
      this.showData = false;
    }
  }

  getClusterData() {
    this.dashboardsqlservice.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.validationMsg = 'Failed to get the cluster. Please try after sometime.';
        this.showValidation = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.clusterdefault = this.cluster[0];
        this.loading = false;
      }
    }, (error) => {
      this.validationMsg = 'Failed to get the cluster. Please try after sometime.';
      this.showValidation = true;
      this.loading = false;
    });
  }

  getIncidentDataUploadData() {
    this.incidentStatusService.getIncidentDataUploadStatusData().subscribe(response => {
      this.dataAvailable = true;
      if (response !== null && response.length > 1) {
        const incidentuploadstatusdata = [];
        const overalluploadstatusdata = [];
        response.forEach(e => {
          let object = {};
          object = {
            subregion: e.subRegion,
            noofsites: e.noofsites,
            noofsitesuploadeddata: e.noofsitesuploadeddata,
            datauploadpercentage: e.datauploadpercentage
          };
          if (e.subRegion === 'Overall') {
            overalluploadstatusdata.push(object);
          } else {
            incidentuploadstatusdata.push(object);
          }
        });
        this.overallDataUploadStatusDataSource = overalluploadstatusdata;
        this.incidentDataUploadStatusDataSource = incidentuploadstatusdata;
      }
    });
  }

  getIncidentDataUploadClusterData() {
    this.incidentStatusService.getIncidentDataUploadClusterData().subscribe(response => {
      this.dataAvailable = true;
      if (response !== null && response.length > 1) {
        const incidentuploadclusterdata = [];
        response.forEach(e => {
          let object = {};
          object = {
            subregion: e.subRegion,
            site: e.site,
            businessgroup: e.businessGroup,
            lastupdateddate: e.lastupdateddate,
            lastupdateduser: e.lastupdateduser
          };
          incidentuploadclusterdata.push(object);
        });
        this.incidentDataUploadClusterDataArray = incidentuploadclusterdata;
        this.loadIncidentDataUploadClusterData();
      }
    });
  }

  updateClusterData() {
    this.clusterdefault = this.incidentUploadForm.get('clusters').value;
    this.loadIncidentDataUploadClusterData();
  }

  loadIncidentDataUploadClusterData() {
    this.incidentDataUploadClusterDataSource = [];
    this.incidentDataUploadClusterDataArray.forEach(e => {
      if (this.clusterdefault === e.subregion) {
        let object = {};
        object = {
          subregion: e.subregion,
          site: e.site,
          businessgroup: e.businessgroup,
          lastupdateddate: e.lastupdateddate,
          lastupdateduser: e.lastupdateduser
        };
        this.incidentDataUploadClusterDataSource.push(object);
      }
    });
    this.dataSource = new MatTableDataSource(this.incidentDataUploadClusterDataSource);
    this.dataSource.paginator = this.paginator;
  }

  onTabClick(event: any) {
    this.seletedTabIndex = event.index;
    console.log('seletedTabIndex: ' + this.seletedTabIndex);
  }

  loadIncidentDataUploadDetails() {
    if (this.seletedTabIndex === 0) {
      this.getIncidentDataUploadData();
    } else if (this.seletedTabIndex === 1) {
      this.getIncidentDataUploadClusterData();
    }
  }

}
